function createExplorerMessenger() {
  const isBrowser = typeof window !== "undefined";
  return {
    sendMessage(message) {
      isBrowser && window.postMessage(message, "*");
    }
  };
}
export {
  createExplorerMessenger
};
